// @flow
export const scale = (windowWidth: number, value: number): number =>
  Math.round(value * windowWidth * 0.00052)
